// @ts-nocheck
export function getMediaType(fileName) {
  const mediaTypes = {
    ppt: ["ppt", "pptx"],
    docx: ["doc", "docx", "rtf", "txt"],
    excel: ["xls", "xlsx", "csv"],
    image: ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "svg"],
    video: ["mp4", "avi", "mkv", "mov", "wmv", "flv"],
    music: ["mp3", "wav", "aac", "flac", "ogg", "m4a"],
    // compressed: ["zip", "rar", "7z", "tar", "gz"],
    // web: ["html", "htm", "css", "js"],
    other: [".md", ".csv"],
    pdf: ["pdf"],
  };
  const extension = fileName.split(".").pop().toLowerCase();

  for (const [mediaType, extensions] of Object.entries(mediaTypes)) {
    if (extensions.includes(extension)) {
      return mediaType;
    }
  }

  return "other";
}